import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  buildI18nextResources,
  DEFAULT_LOCALE,
  detectBrowserLocale,
  ensureLocalePrefix,
  isAppLocale,
  localeFromPathname,
  LOCALE_CODES,
  redirectLegacyUkLocalePath,
  replaceLocaleInUrl,
  type AppLocale,
} from '@redevicer/shared'

const STORAGE_KEY = 'redevicer_lang'

let syncingLocaleFromUrl = false

function storedLocale(): AppLocale | null {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return v && isAppLocale(v) ? v : null
  } catch {
    return null
  }
}

function resolveInitialLocale(): AppLocale {
  if (typeof window !== 'undefined') {
    const fromUrl = localeFromPathname(window.location.pathname)
    if (fromUrl) return fromUrl
  }
  return storedLocale() ?? detectBrowserLocale() ?? DEFAULT_LOCALE
}

if (typeof window !== 'undefined') {
  redirectLegacyUkLocalePath()
}

const initialLng = resolveInitialLocale()

if (typeof window !== 'undefined') {
  ensureLocalePrefix(initialLng)
}

i18n.use(initReactI18next).init({
  resources: buildI18nextResources(),
  lng: initialLng,
  fallbackLng: {
    default: ['en'],
    ...Object.fromEntries(LOCALE_CODES.filter((c) => c !== 'en').map((c) => [c, ['en', DEFAULT_LOCALE]])),
  },
  interpolation: {
    escapeValue: false,
  },
})

i18n.on('languageChanged', (lng) => {
  try {
    if (isAppLocale(lng)) localStorage.setItem(STORAGE_KEY, lng)
  } catch {
    /* ignore */
  }
  if (!syncingLocaleFromUrl && isAppLocale(lng)) {
    replaceLocaleInUrl(lng)
  }
})

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    const loc = localeFromPathname(window.location.pathname)
    if (!loc || loc === i18n.language) return
    syncingLocaleFromUrl = true
    void i18n.changeLanguage(loc).finally(() => {
      syncingLocaleFromUrl = false
    })
  })
}

export default i18n
